// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"adc58e0b","351":"adc58e0b","353":"63d355e6","786":"924b88d0"}[chunkId] + ".chunk.css";
};